export const iconFontAwesomeHalloweenSkullCrossbones = (
	<i className="fa-solid fa-skull-crossbones"></i>
);
